import ApplicationAdvancedForm from './ApplicationAdvancedForm'

export default ApplicationAdvancedForm
